module.exports = __webpack_public_path__ + "static/media/waitList.8c25c4aa.png";